export default function Skeleton({width, height}){
    return (
        <div className="skeleton d-inline-block" style={{width: width, height: height}}></div>
    )
}